import StepsDescriptionReward from './steps-description-reward.container';

export default StepsDescriptionReward;
